








































































































































































































import Menu from '@/components/Issue/Menu.vue'
import {SimpleResponse} from '@/models/Model'
import {OpcBlock, TruckConst} from '@/models/OpcBlock'
import {DataArray} from '@/models/Response'
import {Component, Vue} from 'vue-property-decorator'
import LoadingDummy from '../components/LoadingDummy.vue'
import Helper from '../services/Helper.js'

@Component({
    components: {LoadingDummy, Menu},
})
export default class ViewOpcBlock extends Vue {

    search = ''

    drawer_ratio = 0.15
    drawer_width = 200

    show_password = false

    objects: OpcBlock[] = []

    objectLoading = false
    objectsLoading = false
    EditObjectDialog = false
    selectedObject: OpcBlock | null = null

    TruckConst = TruckConst


    async toggleObject(object: OpcBlock) {
        this.objectLoading = true

        const url = Helper.setting.opc_block.toggleResourceAPI.replace('{id}', object.id)
        try {
            const response = await Helper.post(url, {})
            object.status = 'DONE'
            this.$root.$emit('onSuccess', {message: response.data.message})
        } catch (e) {
            this.$root.$emit('onError', {message: e.toString()})
        }
        this.objectLoading = false

    }

    async clearObject(object: OpcBlock) {
        this.objectLoading = true

        const url = Helper.setting.opc_block.clearResourceAPI.replace('{id}', object.id)

        try {
            const response = await Helper.post(url, {})
            object.shop_no = ''
            object.status = ''
            this.$root.$emit('onSuccess', {message: response.data.message})
        } catch (e) {
            this.$root.$emit('onError', {message: e.toString()})
        }
        this.objectLoading = false

    }
    async editIssue(object: OpcBlock) {

      if (object.issue_id) {
        this.$root.$emit('openIssue', {id:object.issue_id})
      }



    }
    async editObject(object: OpcBlock) {
        this.objectLoading = true

        this.EditObjectDialog = true

        if (object.id) {
            this.selectedObject = await (new OpcBlock()).load<OpcBlock>(object.id)
        }

        this.objectLoading = false

    }

    newObject() {
        this.selectedObject = new OpcBlock()
        this.EditObjectDialog = true

    }

    cancel() {

        this.EditObjectDialog = false
    }

    async onSubmitObject() {
        this.objectLoading = true
        const isNew = this.selectedObject?.id === null

        this.selectedObject = Object.setPrototypeOf(this.selectedObject, OpcBlock.prototype)

        if (this.selectedObject) {
            let object = await this.selectedObject.save<OpcBlock>()
            this.$root.$emit('onSuccess', {message: 'บันทึกสำเร็จ'})

            this.objectLoading = false

            if (isNew) {
                this.objects.push(object)
            } else {
                for (let i in this.objects) {
                    if (this.objects[i].id == object.id) {
                        this.objects[i] = object
                    }
                }
            }
        }
        this.selectedObject = null
        this.EditObjectDialog = false
    }

    async deletingObject() {
        this.$confirm('ยืนยันลบข้อมูล?').then(res => {
            if (res) {
                this.deleteObject()
            }
        })

    }

    async deleteObject() {
        try {
            if (this.selectedObject == null) return
            this.objectLoading = true

            this.selectedObject = Object.setPrototypeOf(this.selectedObject, OpcBlock.prototype)

            const response: SimpleResponse = await this.selectedObject?.delete()

            this.objects = this.objects.filter(object => object.id != this.selectedObject?.id)

            this.selectedObject = null
            this.EditObjectDialog = false

            this.$root.$emit('onSuccess', {message: response.toString()})
        } catch (e) {
            console.log(e)
            this.$root.$emit('onError', {message: e.toString(), error: e})
        }
        this.objectLoading = false
    }

    async mounted() {
        this.drawer_width = Math.max(80, Math.round(window.innerWidth * this.drawer_ratio))
        console.log('window.innerWidth', window.innerWidth)


        this.refreshTruck().then(() => {
        })
    }

    async refreshTruck() {
        const url = Helper.setting.opc_block.getListAPI

        try {
            this.objectsLoading = true
            this.objects = await Helper.get(url).then<{ data: DataArray }>(({data}) => data.data)
        } catch (e) {
            alert(e)
        }
        this.objectsLoading = false
    }

}
